// extracted by mini-css-extract-plugin
export default {"box":"payment_box__H6ve7","inp":"payment_inp__Emp8F","header":"payment_header__FTIOE"};